export const RedirectActions = {
  Favorite: 'favorite',
  WriteCasinoReview: 'writecasinoreview',
  WriteCasinoSlotReview: 'writecasinoslotreview',
  WriteSlotReview: 'writeslotreview',
};
